import { http } from "./http";

export type StockReceiptItem = {
  variant_id: number;
  stock_type: "in_store" | "online";
  quantity: number;
  unit_cost: number;
};

export type StockReceiptPayload = {
  supplier_id: number;
  invoice_number?: string;
  order_number: string;
  delivery_date?: string;
  invoice_date?: string;
  note?: string;
  discount_amount?: number;
  shipping_cost?: number;
  import_duty?: number;
  items: StockReceiptItem[];
};

export const createStockReceipt = async (payload: StockReceiptPayload) => {
  const res = await http.post("/api/admin/stock-receipts", payload);
  return res.data;
};

export const getAllStockReceipts = async () => {
  const res = await http.get("/api/admin/stock-receipts");
  return res.data.receipts;
};

export const getStockReceiptById = async (id: number) => {
  const res = await http.get(`/api/admin/stock-receipts/${id}`);
  return res.data;
};

// NEW: search products by name (returns product with variants)
export const searchProductsWithVariants = async (query: string) => {
  const res = await http.get("/products/search", {
    params: { query },
  });
  return res.data;
};

export const updateReceiptItemPrices = async (
  receiptId: number,
  items: { id: number; unit_cost: number; price: number }[]
) => {
  const res = await http.patch(
    `/api/admin/stock-receipts/${receiptId}/update-prices`,
    { items }
  );
  return res.data;
};

export const getReorderList = async (threshold?: number) => {
  const res = await http.get("/api/admin/stock/reorder-list", {
    params: threshold !== undefined ? { threshold } : {},
  });
  console.log(res);
  return res.data.items;
};

// Get global reorder threshold
export const getGlobalReorderThreshold = async (): Promise<number> => {
  const res = await http.get("/api/admin/stock/get-global-threshold");
  return res.data.threshold;
};

// Set global reorder threshold
export const setGlobalReorderThreshold = async (threshold: number) => {
  const res = await http.patch("/api/admin/stock/set-global-threshold", {
    threshold,
  });
  return res.data;
};

// Get per-product reorder thresholds
export const getProductReorderThresholds = async (): Promise<
  { product_id: number; product_name: string; sku: string; reorder_threshold: number | null }[]
> => {
  const res = await http.get("/api/admin/stock/reorder-thresholds");
  return res.data.products;
};

// Set per-product reorder thresholds
export const setProductReorderThresholds = async (
  products: { product_id: number; reorder_threshold: number | null }[]
) => {
  const res = await http.patch("/api/admin/stock/set-product-thresholds", {
    products,
  });
  return res.data;
};

export const getAllSuppliers = async () => {
  const res = await http.get("/api/admin/suppliers");
  return res.data.suppliers;
};

export const setPrimarySupplier = async (product_id: number, supplier_id: number) => {
  const res = await http.patch("/api/admin/stock/set-primary-supplier", {
    product_id,
    supplier_id,
  });
  return res.data;
};